var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgQuoteCampaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.2858 6.21734H21.6667H20.3572C19.637 6.21734 19.0477 5.63039 19.0477 4.913V1L24.2858 6.21734Z",
    fill: "#02B7E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98816 4.91321H10.5358",
    stroke: "#174466",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98816 7.52148H5.29769",
    stroke: "#174466",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60712 7.52148H7.91664",
    stroke: "#174466",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2857 29.6962C24.2857 30.4136 23.6964 31.0005 22.9762 31.0005H2.02376C1.30352 31.0005 0.714233 30.4136 0.714233 29.6962V2.30519C0.714233 1.5878 1.30352 1.00085 2.02376 1.00085H19.0476L24.2857 6.21819V29.6962Z",
    stroke: "#174466",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6668 6.21734H20.3573C19.637 6.21734 19.0477 5.63039 19.0477 4.913V1",
    stroke: "#174466",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.2857 27.4288H10V22.59C10 21.2076 11.0714 20.2859 12.1429 20.2859C13.2143 20.2859 14.2857 20.9771 14.2857 22.59V27.4288Z",
    fill: "#02B7E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4277 26.9525V22.3994C14.4277 21.1473 13.3992 20.1229 12.1422 20.1229",
    stroke: "#174466",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85655 26.9525V22.3994C9.85655 21.1473 10.8851 20.1229 12.1422 20.1229",
    stroke: "#174466",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7741 15.3477L11.8455 11.4347L5.29785 17.1941V25.7824C5.29785 26.4998 5.88714 27.0867 6.60738 27.0867H18.3931C19.1134 27.0867 19.7026 26.4998 19.7026 25.7824V19.2607L17.6278 17.1941M15.7741 15.3477V13.5209H17.6278V17.1941M15.7741 15.3477L17.6278 17.1941",
    stroke: "#174466",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteCampaign);
export default __webpack_public_path__ + "static/media/quote-campaign.0ca22e66c39999dd9962643d5cca836d.svg";
export { ForwardRef as ReactComponent };